// @ts-nocheck
// Plant Card
$(document).ready(function () {
  function renderDiscoverPlants($discoverPlants) {
    var $sourceEntries = $discoverPlants.find('.discover-plants__source-entry');
    var $imagesContainer = $discoverPlants.find('[data-plants-images]');
    var $mobileCardsContainer = $discoverPlants.find('[data-plants-mobile-cards]');
    var $desktopCardsContainer = $discoverPlants.find('[data-plants-desktop-cards]');

    if (!$imagesContainer.length || !$mobileCardsContainer.length || !$desktopCardsContainer.length) {
      return;
    }

    $discoverPlants.removeClass('discover-plants--mobile-card-open');
    $imagesContainer.empty();
    $mobileCardsContainer.empty();
    $desktopCardsContainer.empty();

    $sourceEntries.each(function (index) {
      var $source = $(this);
      var $image = $source.children('.plant-image-item').first().clone();
      var $mobileCard = $source.children('.plant-card--mobile').first().clone();
      var $desktopCard = $source.children('.plant-card--desktop').first().clone();

      $image.attr('data-index', index);
      $mobileCard.attr('data-index', index).removeClass('plant-card--mobile');
      $desktopCard.attr('data-index', index).removeClass('plant-card--desktop');

      if (index === 0) {
        $image.addClass('active');
        $desktopCard.addClass('active');
      }

      $imagesContainer.append($image);
      $mobileCardsContainer.append($mobileCard);
      $desktopCardsContainer.append($desktopCard);
    });
  }

  function renderDiscoverPlantsInContext(context) {
    $(context).find('.discover-plants').addBack('.discover-plants').each(function () {
      renderDiscoverPlants($(this));
    });
  }

  renderDiscoverPlantsInContext(document);

  $(document).on('shopify:section:load shopify:section:reorder shopify:block:select shopify:block:deselect', function (event) {
    renderDiscoverPlantsInContext(event.target);
  });

  $(document).on('click', '.discover-plants .plant-image-item', function () {
    var $plantImage = $(this);
    var index = $plantImage.data('index');
    var $discoverPlants = $plantImage.closest('.discover-plants');
    var isMobile = window.matchMedia('(max-width: 991px)').matches;

    $discoverPlants.find('.plant-image-item').removeClass('active');
    $discoverPlants.find('.plant-card').removeClass('active');

    $plantImage.addClass('active');
    $discoverPlants.find('.plant-card[data-index="' + index + '"]').addClass('active');

    if (isMobile) {
      $discoverPlants.addClass('discover-plants--mobile-card-open');
    }
  });

  $(document).on('click', '.discover-plants .plant-card', function (e) {
    var $discoverPlants = $(this).closest('.discover-plants');
    var isMobile = window.matchMedia('(max-width: 991px)').matches;

    if (!isMobile) {
      return;
    }

    $discoverPlants.find('.plant-card').removeClass('active');
    $discoverPlants.removeClass('discover-plants--mobile-card-open');
  });
});

// Custom Slick Carousel
(function ($) {
  if (!$) return;
  function getNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }
  function parseBoolean(value) {
    return String(value) === 'true';
  }
  function getRootsInContext(context) {
    var $context = $(context || document);
    var $roots = $context.find('[data-custom-slick-carousel-root]');

    if ($context.is('[data-custom-slick-carousel-root]')) {
      $roots = $roots.add($context);
    }
    return $roots;
  }

  function safeUnslick($track) {
    if (!$track || !$track.length) return;
    if (typeof $track.slick !== 'function') return;
    if (!$track.hasClass('slick-initialized')) return;

    try {
      $track.slick('unslick');
    } catch (e) {
      // ignore
    }
  }

  function initCustomSlickCarouselInContext(context) {
    getRootsInContext(context).each(function () {
      var $root = $(this);
      var $track = $root.find('[data-custom-slick-carousel-track]').first();
      if (!$track.length) return;

      if (typeof $track.slick !== 'function') return;

      var slidesDesktop = getNumber($root.attr('data-custom-slick-slides-desktop'), 4);
      var slidesMobile = getNumber($root.attr('data-custom-slick-slides-mobile'), 1);
      var slideCount = getNumber($root.attr('data-custom-slick-slide-count'), $track.children().length);
      if (!slideCount) return;

      var showArrowsFallback = parseBoolean($root.attr('data-custom-slick-arrows'));
      var showArrowsMobile = parseBoolean($root.attr('data-custom-slick-arrows-mobile'));
      var showArrowsDesktop = parseBoolean($root.attr('data-custom-slick-arrows-desktop'));
      var autoplaySetting = parseBoolean($root.attr('data-custom-slick-autoplay'));
      var autoplaySpeed = getNumber($root.attr('data-custom-slick-autoplay-speed'), 3000);

      if ($root.attr('data-custom-slick-arrows-mobile') == null) showArrowsMobile = showArrowsFallback;
      if ($root.attr('data-custom-slick-arrows-desktop') == null) showArrowsDesktop = showArrowsFallback;

      var infiniteSetting = parseBoolean($root.attr('data-custom-slick-infinite'));
      var slidesToShowMobile = Math.max(1, Math.min(slidesMobile, slideCount));
      var slidesToShowDesktop = Math.max(1, Math.min(slidesDesktop, slideCount));
      var infiniteMobile = infiniteSetting && slideCount > slidesToShowMobile;
      var infiniteDesktop = infiniteSetting && slideCount > slidesToShowDesktop;

      var configKey = JSON.stringify({
        slidesToShowMobile: slidesToShowMobile,
        slidesToShowDesktop: slidesToShowDesktop,
        showArrowsMobile: showArrowsMobile,
        showArrowsDesktop: showArrowsDesktop,
        infiniteMobile: infiniteMobile,
        infiniteDesktop: infiniteDesktop,
      });

      if ($track.hasClass('slick-initialized')) {
        var previousKey = $root.attr('data-custom-slick-config-key');

        if (previousKey && previousKey !== configKey) {
          safeUnslick($track);
        } else {
          try {
            $track.slick('setPosition');
          } catch (e) {
            // ignore
          }
          return;
        }
      }

      var $prev = $root.find('[data-custom-slick-carousel-prev]').first();
      var $next = $root.find('[data-custom-slick-carousel-next]').first();

      $root.attr('data-custom-slick-config-key', configKey);

      // ✅ NEW: support decimals + tablet
      var slidesToShowMobile = parseFloat($root.data('custom-slick-slides-mobile')) || 1;
      var slidesToShowDesktop = parseFloat($root.data('custom-slick-slides-desktop')) || 4;
      var slidesToShowTablet = parseFloat($root.data('custom-slick-slides-tablet')) || 2;

      var infiniteTablet = infiniteSetting && slideCount > slidesToShowTablet;
      var showArrowsTablet = showArrowsDesktop;

      var slickConfig = {
        slidesToShow: slidesToShowMobile,
        slidesToScroll: 1,
        arrows: showArrowsMobile,
        prevArrow: $prev.length ? $prev : undefined,
        nextArrow: $next.length ? $next : undefined,
        dots: false,
        infinite: infiniteMobile,
        adaptiveHeight: false,
        mobileFirst: true,
        touchMove: true,
        draggable: true,
        autoplay: autoplaySetting,
        autoplaySpeed: autoplaySpeed,
        pauseOnHover: true,
        pauseOnFocus: true,
        responsive: [
          {
            breakpoint: 768, // ≥768px → tablet starts
            settings: {
              slidesToShow: slidesToShowTablet,
              slidesToScroll: 1,
              arrows: showArrowsDesktop,
              infinite: infiniteSetting && slideCount > slidesToShowTablet,
              adaptiveHeight: false,
            },
          },
          {
            breakpoint: 1024, // ≥1024px → desktop starts
            settings: {
              slidesToShow: slidesToShowDesktop,
              slidesToScroll: 1,
              arrows: showArrowsDesktop,
              infinite: infiniteDesktop,
              adaptiveHeight: false,
            },
          },
        ],
      };

      $track.slick(slickConfig);

      requestAnimationFrame(function () {
        if ($track.hasClass('slick-initialized')) {
          $track.slick('setPosition');
        }
      });
      setTimeout(function () {
        if ($track.hasClass('slick-initialized')) {
          $track.slick('setPosition');
        }
      }, 50);
      setTimeout(function () {
        if ($track.hasClass('slick-initialized')) {
          $track.slick('setPosition');
        }
      }, 150);

      var $images = $track.find('img');
      if ($images.length) {
        var loadedCount = 0;
        $images.on('load', function () {
          loadedCount++;
          if (loadedCount === $images.length && $track.hasClass('slick-initialized')) {
            setTimeout(function () {
              $track.slick('setPosition');
            }, 10);
          }
        });

        setTimeout(function () {
          if ($track.hasClass('slick-initialized')) {
            $track.slick('setPosition');
          }
        }, 300);
      }
    });
  }

  function destroyCustomSlickCarouselInContext(context) {
    getRootsInContext(context).each(function () {
      var $root = $(this);
      var $track = $root.find('[data-custom-slick-carousel-track]').first();
      if (!$track.length) return;
      if (typeof $track.slick !== 'function') return;

      safeUnslick($track);
    });
  }

  $(function () {
    initCustomSlickCarouselInContext(document);
  });

  $(window).on('load', function () {
    initCustomSlickCarouselInContext(document);
    getRootsInContext(document).each(function () {
      var $track = $(this).find('[data-custom-slick-carousel-track]').first();
      if ($track.length && $track.hasClass('slick-initialized')) {
        $track.slick('setPosition');
      }
    });
  });

  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      getRootsInContext(document).each(function () {
        var $track = $(this).find('[data-custom-slick-carousel-track]').first();
        if ($track.length && $track.hasClass('slick-initialized')) {
          $track.slick('setPosition');
        }
      });
    }, 100);
  });

  $(document).on(
    'shopify:section:load shopify:section:reorder shopify:section:select shopify:block:select shopify:block:deselect',
    function (event) {
      initCustomSlickCarouselInContext(event.target);
    }
  );

  $(document).on('shopify:section:unload', function (event) {
    destroyCustomSlickCarouselInContext(event.target);
  });
})(window.jQuery);

// Annoucement Bar Top

function updateLayout() {
var announcementHeight = $('.announcement-bar').outerHeight();
$('.header-section').css('top', announcementHeight);
}

$(document).ready(function () {
  updateLayout();
});
$(window).on('resize', function () {
  updateLayout();
});

//Header not sticky for footer
$(document).ready(function () {
  var $header = $('.header-section');
  var $announcement = $('.announcement-bar-main');
  var $footer = $('footer');
  var $headerComponent = $('#header-component');

  $(window).on('scroll', function () {
    var stickyMode = $headerComponent.attr('sticky');

    // On 'always' sticky pages, we don't want the header to hide at the footer
    if (stickyMode === 'always') {
      $header.css('position', '');
      $announcement.css('position', '');
      return;
    }

    var footerRect = $footer.length ? $footer[0].getBoundingClientRect() : { top: 99999 };
    var headerHeight = $header.outerHeight() + $announcement.outerHeight();

    // When footer reaches header area
    if (footerRect.top <= headerHeight) {
      $header.css('position', 'relative');
      $announcement.css('position', 'relative');
    } else {
      // Clear inline styles to let custom-header.css [position: sticky] take over smoothly
      $header.css('position', '');
      $announcement.css('position', '');
    }
  });
});

// Sticky-effect — position: fixed on scroll with dynamic header offset
$(document).ready(function () {
  function applyStickyEffect() {
    var $stickyWrappers = $('.section-wrapper:has(.sticky-effect)');
    var headerHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) || $('.header-section').outerHeight() || 0;
    var scrollTop = $(window).scrollTop();

    $stickyWrappers.each(function () {
      var $el = $(this);
      var initialOffset = $el.data('sticky-offset');
      var isFixed = $el.hasClass('sticky-effect--fixed');

      if (typeof initialOffset === 'undefined') {
        initialOffset = $el.offset().top;
        $el.data('sticky-offset', initialOffset);
        $el.data('sticky-width', $el.outerWidth());
      }

      if (scrollTop >= initialOffset - headerHeight && !isFixed) {
        var elHeight = $el.outerHeight();
        $el.addClass('sticky-effect--fixed');
        $el.before('<div class="sticky-effect-spacer" style="height:' + elHeight + 'px"></div>');
        $el.css({
          position: 'fixed',
          top: headerHeight + 'px',
          width: $el.data('sticky-width') + 'px'
        });
      } else if (scrollTop < initialOffset - headerHeight && isFixed) {
        $el.removeClass('sticky-effect--fixed');
        $el.siblings('.sticky-effect-spacer').remove();
        $el.css({
          position: '',
          top: '',
          width: ''
        });
      }
    });
  }

  applyStickyEffect();
  $(window).on('scroll', applyStickyEffect);
  $(window).on('resize', function () {
    $('.section-wrapper:has(.sticky-effect)').not('.sticky-effect--fixed').removeData('sticky-offset').removeData('sticky-width');
    applyStickyEffect();
  });
});

// Table Compare
$(function () {
  const $rows = $(".compare-row");
  const $btn = $("#toggle-compare");
  const $extraRows = $rows.slice(7);

  $extraRows.hide();

  $btn.on("click", function () {
    const isOpen = $extraRows.is(":visible");

    $extraRows.toggle();
    $btn.toggleClass("visible-toggle", !isOpen);

    $btn.text(isOpen ? "Compare full specs" : "Hide full specs");
  });
});

// Calculator JS
// Cards are identified by data-product-index: 0 = Product 1, 1 = Product 2

//CORE STATE FUNCTION
function setActiveProduct($calculator, index) {
  var $card = $calculator.find('.calculator-card[data-product-index="' + index + '"]');

  if (!$card.length) return;
  // update cards
  $calculator.find('.calculator-card').removeClass('card-selected');
  $card.addClass('card-selected');

  // update switchers (both cards)
  $calculator.find('.product-switcher li').removeClass('active');
  $calculator.find('.product-switcher li[data-product-index="' + index + '"]').addClass('active');
}

// Counter
$(document).on('click', '.product-calculator .counter-plus, .product-calculator .counter-minus', function () {
  var input = $(this).siblings('input[type="number"]');
  var currentVal = parseInt(input.val()) || 1;
  var min = parseInt(input.attr('min')) || 1;
  var max = 9;

  if ($(this).hasClass('counter-plus')) {
    if (currentVal < max) {
      input.val(currentVal + 1);
    }
  }
  if ($(this).hasClass('counter-minus')) {
    if (currentVal > min) {
      input.val(currentVal - 1);
    }
  }
  input.trigger('change');
});

// Calculation
$(document).on('change', '.product-calculator input[name="people"], .product-calculator input[name="salads"]', function () {
  var $calculator = $(this).closest('.product-calculator');
  var people = parseInt($calculator.find('input[name="people"]').val()) || 1;
  var salads = parseInt($calculator.find('input[name="salads"]').val()) || 1;
  var threshold = parseInt($calculator.data('recommend-threshold')) || 8;

  var result = people * salads;

  // mapping logic → product selection
  setActiveProduct($calculator, result <= threshold ? 1 : 0);
});

// Switcher
$(document).on('click', '.product-calculator .product-switcher li', function () {
  setActiveProduct($(this).closest('.product-calculator'), $(this).data('product-index'));
});

// INITIAL LOAD SYNC
$(document).ready(function () {
  $('.product-calculator').each(function () {
    var $calculator = $(this);
    // Use Shopify/Liquid default
    var initialIndex = $calculator.find('.calculator-card.card-selected').first().data('product-index');

    setActiveProduct($calculator, initialIndex === undefined ? 0 : initialIndex);
  });
});

// Flip Card
$(document).on('click', '.flip-card', function() {
  $(this).toggleClass('flipped-card');
});


$(document).ready(function () {
  $('.pricing-tabs').each(function () {
    var $tabsRoot = $(this);
    var $titlesWrapper = $('<div class="pricing-tabs__titles"></div>');
    var $contentsWrapper = $('<div class="pricing-tabs__contents"></div>');

    $tabsRoot.prepend($titlesWrapper, $contentsWrapper);

    var $rows = $tabsRoot.find('.pricing-tabs-row');
    $rows.each(function (index) {
      var $row = $(this);
      var $title = $row.find('.pricing-tab-title').first();
      var $content = $row.find('.pricing-tab-contents').first();

      if (!$title.length || !$content.length) {
        return;
      }

      $title.attr('data-pricing-tab-index', index);
      $content.attr('data-pricing-tab-index', index);
      $titlesWrapper.append($title);
      $contentsWrapper.append($content);
      $row.remove();
    });

    var $titles = $titlesWrapper.children('.pricing-tab-title');
    var $contents = $contentsWrapper.children('.pricing-tab-contents');

    if ($titles.length) {
      $titles.removeClass('active');
      $titles.first().addClass('active');
    }

    if ($contents.length) {
      $contents.hide();
      $contents.first().show();
    }

    $titles.on('click', function () {
      var tabIndex = $(this).attr('data-pricing-tab-index');
      $titles.removeClass('active');
      $(this).addClass('active');
      $contents.hide();
      $contents.filter('[data-pricing-tab-index="' + tabIndex + '"]').show();
    });
});
});


// Tooltip
$(document).ready(function () {

  $('.tooltip-trigger').click(function (e) {
    e.stopPropagation();

    let wrapper = $(this).closest('.tooltip-main');
    let tooltip = wrapper.find('.tooltip-content');

    // close others
    $('.tooltip-content').not(tooltip).fadeOut(150);

    // toggle
    tooltip.fadeToggle(150);

    // 👉 calculate center of button relative to tooltip
    let btnOffset = $(this).offset().left;
    let tooltipOffset = tooltip.offset().left;
    let btnWidth = $(this).outerWidth();

    let arrowLeft = (btnOffset - tooltipOffset) + (btnWidth / 2);

    // set CSS variable
    tooltip.css('--arrow-left', arrowLeft + 'px');
  });

  // prevent closing when clicking inside tooltip
  $('.tooltip-content').click(function (e) {
    e.stopPropagation();

    // inside a label (e.g. product list cards), don't let the click select the input - links still work
    if ($(this).closest('label').length && !$(e.target).closest('a').length) {
      e.preventDefault();
    }
  });

  // outside click closes
  $(document).click(function () {
    $('.tooltip-content').fadeOut(150);
  });

});

// Help Popup
$(document).ready(function(){
  // Move all modals to body (important)
  $('.help-modal').each(function(){
    console.log('Moving modal to body');
    $(this).appendTo('body');
  });
});

// Open modal
$(document).on('click', '.product-help-btn', function(){
  var modalId = $(this).data('modal');
  $('#' + modalId).fadeIn();
  $('body').addClass('modal-overlay');
});

// Close modal
$(document).on('click', '.help-modal-close', function(){
  $(this).closest('.help-modal').fadeOut();
  $('body').removeClass('modal-overlay');
});

// Click outside
$(document).on('click', '.help-modal', function(e){
  if ($(e.target).hasClass('help-modal-body')) {
    $(this).fadeOut();
    $('body').removeClass('modal-overlay');
  }
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:block:select', function(event) {
    const selectedBlock = event.target;
    if (!(selectedBlock instanceof HTMLElement)) return;

    const helpPopupBlock = selectedBlock.matches('[data-help-popup-block]')
      ? selectedBlock
      : selectedBlock.closest('[data-help-popup-block]');

    if (helpPopupBlock) {
      const trigger = helpPopupBlock.querySelector('.product-help-btn');
      const modalId = trigger?.dataset.modal;

      $('.help-modal').fadeOut(0);
      $('body').removeClass('modal-overlay');

      if (modalId) {
        $('#' + modalId).fadeIn(0);
        $('body').addClass('modal-overlay');
      }

      helpPopupBlock.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
      return;
    }

    $('.help-modal').fadeOut(0);
    $('body').removeClass('modal-overlay');
  });
}


document.querySelectorAll('.sticky-announcement-bar .primary-btn, .banner_main-button .primary-btn').forEach(function(button) {

  button.addEventListener('click', function(e) {
    e.preventDefault();

    document.querySelector('.product-info').scrollIntoView({
      behavior: 'smooth'
    });
    
  });

});

function hideTriggerButtonInShadowRoots() {
  document.querySelectorAll('*').forEach(function (element) {
    if (!element.shadowRoot) return;
    var triggerButton = element.shadowRoot.querySelector('.trigger-button--visible');
    if (triggerButton) {
      triggerButton.style.display = 'none';
    }
  });
}

function initTriggerButtonShadowHide() {
  hideTriggerButtonInShadowRoots();
  var observer = new MutationObserver(function () {
    hideTriggerButtonInShadowRoots();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTriggerButtonShadowHide);
} else {
  initTriggerButtonShadowHide();
}

